const $offCanvas = $('.SearchForm--OffCanvas');
const $offCanvasTrigger = $('.SearchSubmit--OffCanvas');
const $offCanvasInput = $offCanvas.find('input[type=text]');

$offCanvasTrigger.on('click', function () {
  $offCanvas.addClass('active');
  $offCanvasInput.focus();
});

$offCanvas.on('focusout', function () {
  if (!$.contains($offCanvas, document.activeElement)) {
    $offCanvas.removeClass('active');
  }
});
